import { useState } from "react"
import LayoutModal from "../../../../../components/layouts/layout_modal"
import BtnDefault from "../../../../../components/buttons/btn_default"
import CustomSpinner from "../../../../../components/customs/spinner"
import TextAreaDefault from "../../../../../components/form/text_area_default"
import { postSellingUpdate } from "../../../../../services/update/selling_update_service"
import { postProcurementUpdate } from "../../../../../services/update/procurement_update_service"

const ProcurementUpdate = ({ open, setOpen, id, setRefresh, accessToken, category }) => {
    const [loading, setLoading] = useState(false)

    const [description, setDescription] = useState("")
    const [errorDescription, setErrorDescription] = useState("")

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            const data = new FormData()
            data.append('category', category)
            data.append('procurement_id', id)
            data.append('description', description);
            const response = await postProcurementUpdate(accessToken, data)
            if (response.status === 201) {
                setOpen(false)
            }else{

            }
        } catch (error) {
            
        }
        setLoading(true)
    }
    return (
        <LayoutModal name={"Hapus Pengadaan Barang"} open={open} setOpen={setOpen}    >
            <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                    <TextAreaDefault
                        label={"Alasan Update Data"}
                        value={description}
                        setValue={setDescription}
                        errorMessage={errorDescription}
                    />
                </div>

                <div className="w-full flex items-center gap-3 justify-evenly">
                    <BtnDefault
                        type="button"
                        handleClick={() => {
                            setOpen(false)
                        }}
                        addClass='bg-red-500 w-full '
                    >
                        Kembali
                    </BtnDefault>
                    <BtnDefault type="submit" addClass='w-full'>
                        {loading === true ? <CustomSpinner addClass='' /> : "Simpan"}
                    </BtnDefault>
                </div>
            </form>

        </LayoutModal>


    )
}

export default ProcurementUpdate